import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import CouponCommon from 'common/components/entities/Coupon'
import { voidFunc } from 'common/utils/void-function'
import React from 'react'
import { CouponInterface } from 'src/shared/entities/coupon/coupon.schema'

export default function Coupon({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<CouponInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CouponCommon
        {...entity}
        isChecking={false}
        onCodeChange={voidFunc}
        onCheck={voidFunc}
      />
    </BaseEntityNew>
  )
}
